// Module
var code = "<md-select ng-model=\"vm.search\" placeholder=\"{{ 'search' | translate }}\" md-on-open=\"vm.getItems()\"\r\n           class=\"md-table-select\" md-container-class=\"md-table-select\" multiple=\"false\"\r\n           ng-change=\"vm.change()\">\r\n    <md-option ng-repeat=\"item in vm.items track by $index\"></md-option>\r\n</md-select>";
// Exports
module.exports = code;